import { useQuery } from '@tanstack/react-query';
import { useAccount } from 'wagmi';
import config from '../config/config';
import useAppStore from '../stores/appStore';

export const useIpKycService = () => {
  const { address } = useAccount();
  const { fetchIsRestricted } = useAppStore();

  useQuery({
    queryKey: ['detectAndCheckIp'],
    queryFn: () => fetchIsRestricted(address!),
    refetchInterval: 60 * 1000,
    enabled: config.get('env') === 'production' && !!address,
  });
};
